import { getContrastYiq } from './getContrastYiq';
export const getTextVariables = ({ key, id, color }) => {
    const mode = getContrastYiq(color);
    const idString = id ? `-${id}` : '';
    const options = {
        light: ['var(--text-color-light-primary)', 'var(--text-color-light-secondary)'],
        dark: ['var(--text-color-dark-primary)', 'var(--text-color-dark-secondary)'],
    };
    return {
        [`--color-${key}${idString}-text-primary`]: options[mode][0],
        [`--color-${key}${idString}-text-secondary`]: options[mode][1],
    };
};
//# sourceMappingURL=getTextVariables.js.map